export default __webpack_public_path__ + "static/media/facility_01_4.4b52d8f1.png";